<div [ngClass]="labelClasses">
  <div
    [ngClass]="{
      'relative flex items-end px-1 mb-1': true,
      'flex-col': helpDialog?.position === 'below'
    }"
  >
    <label
      [ngClass]="{'font-semibold text-gray-600 text-base':true}"
      [attr.for]="key"
      >{{ label }} @if (subLabel) {
      <span class="mb-2 block text-sm font-normal text-gray-500"
        >{{ subLabel }}</span
      >
      }</label
    >
    <div class="flex-shrink-0">
      @if (helpDialog) {
      <pax-help-dialog-button
        [label]="helpDialog.buttonLabel || label"
        [dialogPosition]="helpDialog.position || 'right'"
        (openDialog)="openDialog.emit()"
      />
      }
    </div>
  </div>
</div>
